import api from "../../../api";
import React from "react";
import utils from "../../../utils";
import values from "../../../values";
import Context from "../../../context";
import CompanyScreen from "..";

import { TModal } from "../../../types/common.type";
import { useQuery } from "react-query";
import { DeleteModal } from "../../../components";
import {
  IFindUserInformation,
  UpdateAbsent,
} from "../../../types/common.interface";
import { ICreateAndUpdateCompany } from "../../../types/company.interface";
import { AbsentScreen } from "../..";

const AbsentContainer = () => {
  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Value Validations
  // ** --------------------------------------------------------------------------------------------------------------------
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedAbsent, setSelectedAbsent] = React.useState<any>();
  const [allCompanyInfo, setAllCompanyInfo] =
    React.useState<IFindUserInformation>({
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      page: 1,
    });
  const [requestAbsent, setRequestAbsent] =
    React.useState<IFindUserInformation>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      search: { base: "", value: "" },
      filters: {
        province: undefined,
        city: undefined,
        superAgent: undefined,
      },
    });

  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------
  // ? Panel-wide academic year (سال تحصیلی). It has to be part of the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const resultAbsent = useQuery(
    [
      values.useQueryKeys.getAllAbsent,
      requestAbsent?.page,
      requestAbsent?.search?.value,
      requestAbsent?.filters,
      selectedYear?._id,
    ],
    () =>
      api.post.common.findAbsent({
        filters: requestAbsent?.filters,
        search: requestAbsent?.search,
        limit: requestAbsent?.limit,
        page: requestAbsent?.page,
        academicYear: selectedYear?._id,
      })
  );
  const { refetch } = resultAbsent;
  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------

  // async function approveFunction(formData: UpdateAbsent) {
  //   setIsLoading(true);
  //   const result = await api.put.common.updateAbsent(formData);
  //   if (result) {
  //     utils.successHandler(Number(2010));
  //     refetch();
  //     setShowModal("NONE");
  //   }
  //   setIsLoading(false);
  //   return false;
  // }
  async function updateFunction(formData: UpdateAbsent) {
    setIsLoading(true);
    const result = await api.put.common.updateAbsent(formData);
    if (result) {
      utils.successHandler(Number(2010));
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }

  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                JSX Container
  // ?? --------------------------------------------------------------------------------------------------------------------

  return (
    <Context.AbsentScreen.Provider
      value={{
        showModal,
        isLoading,
        setIsLoading,
        setShowModal,
        updateFunction,
        allCompanyInfo,
        selectedAbsent,
        setAllCompanyInfo,
        setSelectedAbsent,
        requestAbsent,
        setRequestAbsent,
        // approveFunction,
      }}
    >
      <AbsentScreen rqAbsent={resultAbsent} role="ADMIN" />
    </Context.AbsentScreen.Provider>
  );

  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default AbsentContainer;
